let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i9X8S")).then(() => parcelRequire('w1yis'));